import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-white" data-id="element-113">
      <div className="max-w-4xl mx-auto bg-white border-2 border-[#1B4332]/10 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 shadow-lg" data-id="element-114">
        <div className="flex-shrink-0" data-id="element-115">
          <ShieldCheck className="w-32 h-32 text-[#1B4332]" data-id="element-116" />
        </div>

        <div className="text-center md:text-left" data-id="element-117">
          <h2 className="text-2xl md:text-3xl font-bold text-[#1B4332] mb-4" data-id="element-118">
            Garantía Total de 7 Días — Sin Riesgo Para Vos
          </h2>
          <p className="text-[#1C1917]/80 mb-6 leading-relaxed" data-id="element-119">
            Si por cualquier motivo sentís que este pack no es para vos, te
            devolvemos el 100% de tu dinero. Sin preguntas, sin complicaciones,
            sin letra chica. Creemos tanto en este material que el riesgo lo
            asumimos nosotros.
          </p>
          <p className="text-sm font-semibold text-[#1B4332] bg-[#E6F4EA] inline-block px-4 py-2 rounded-lg" data-id="element-120">
            Tu compra está protegida. Si no te sirve, recuperás tu dinero. Así
            de simple.
          </p>
        </div>
      </div>
    </section>;
}